import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

const StyledLabel = styled.label`
  margin-top: 10px;
`;

const StyledTextArea = styled.textarea`
  padding: 1rem;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #d0dbfd;
  font-family: inherit;
  &:focus {
    outline: none;
    border-color: #230cc2;
  }
`;

const StyledError = styled.div`
  margin-top: 5px;
  color: red;
`;

const TemplateDescription = ({ values, errors, touched, setFieldValue }) => {
  return (
    <React.Fragment>
      <StyledLabel>
        {getTranslatedString('landlordPortal.documentTemplate.templateDescription')}
      </StyledLabel>
      <StyledTextArea
        name="description"
        value={values.description}
        rows="10"
        cols="30"
        placeholder={getTranslatedString('landlordPortal.documentTemplate.addDescription')}
        onChange={e => setFieldValue('description', e.target.value)}
      />
      {errors.description && touched.description ? (
        <StyledError disabled={true}>{errors.description}</StyledError>
      ) : null}
    </React.Fragment>
  );
};

export default TemplateDescription;
